import { render, staticRenderFns } from "./ModalCrear.vue?vue&type=template&id=5a8d775c&"
import script from "./ModalCrear.vue?vue&type=script&lang=ts&"
export * from "./ModalCrear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports